import * as React from 'react';
import { upsertUserFavourite, deleteUserFavourite, fetchUserFavourites } from '@shared/actions/userFavouriteThunkActions';
import { UserFavouriteTileDetailButton as UserFavouriteTileDetailButtonComponent } from '@shared/components/userFavouriteTileDetailButton';
import { connect } from 'react-redux';
export const mapStateToProps = (state, ownProps)=>{
    return {
        userInfo: state.users,
        userFavourite: state.userFavourite,
        entityId: ownProps.entityId,
        entityType: ownProps.entityType,
        item: ownProps.item,
        className: ownProps.className
    };
};
export const mapDispatchToProps = (dispatch)=>{
    return {
        fetchUserFavouriteData: ()=>dispatch(fetchUserFavourites()),
        savefavourite: (payload, item)=>dispatch(upsertUserFavourite(payload, item)),
        deleteFavourite: (entityGuid, applicationType)=>dispatch(deleteUserFavourite(entityGuid, applicationType))
    };
};
const UserFavouriteTileDetailButton = connect(mapStateToProps, mapDispatchToProps)(UserFavouriteTileDetailButtonComponent);
export default UserFavouriteTileDetailButton;
